var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkflow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7511_66095)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9995 5.37594L13.9906 1.61957C13.5642 1.22002 13.0061 1 12.4191 1H4.78669C3.52581 1 2.5 2.01599 2.5 3.26481V19.8185C2.5 21.0673 3.52581 22.0833 4.78669 22.0833H16.428C17.6889 22.0833 18.7147 21.0673 18.7147 19.8185V7.02119C18.7147 6.40149 18.4541 5.80181 17.9995 5.37594ZM16.7881 5.94141H13.684C13.5694 5.94141 13.4761 5.84904 13.4761 5.73551V2.83804L16.7881 5.94141ZM16.428 20.848H4.78669C4.21356 20.848 3.74729 20.3862 3.74729 19.8185V3.26481C3.74729 2.69717 4.21356 2.23535 4.78669 2.23535H12.2288V5.73551C12.2288 6.53022 12.8816 7.17676 13.684 7.17676H17.4674V19.8185C17.4674 20.3862 17.0012 20.848 16.428 20.848Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9911 13.0361H5.84435C5.49993 13.0361 5.2207 13.3127 5.2207 13.6538C5.2207 13.9949 5.49993 14.2715 5.84435 14.2715H14.9911C15.3355 14.2715 15.6148 13.9949 15.6148 13.6538C15.6148 13.3127 15.3355 13.0361 14.9911 13.0361Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2411 9.4043H5.84435C5.49993 9.4043 5.2207 9.68085 5.2207 10.022C5.2207 10.3631 5.49993 10.6396 5.84435 10.6396H12.2411C12.5855 10.6396 12.8648 10.3631 12.8648 10.022C12.8648 9.68085 12.5855 9.4043 12.2411 9.4043Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9911 16.3311H5.84435C5.49993 16.3311 5.2207 16.6076 5.2207 16.9487C5.2207 17.2899 5.49993 17.5664 5.84435 17.5664H14.9911C15.3355 17.5664 15.6148 17.2899 15.6148 16.9487C15.6148 16.6076 15.3355 16.3311 14.9911 16.3311Z",
    fill: "#111111"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7511_66095"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkflow);
export default __webpack_public_path__ + "static/media/Workflow.2e9695ec2bdf2697740ffff3dfc72b9d.svg";
export { ForwardRef as ReactComponent };